<template>
	<div class="plr20 bf pt20 vh100 bgfff" style="box-sizing: border-box;">
		<div class="bor_b pb20 flex flex_between mb20" @click="show = true">
			<div class=""><span class="red">*</span>请假日期</div>
			<div class="flex flex_items">
				<div class="l1" :class="timer ? '' : 'ca6'">{{timer ? timer : '请选择日期'}}</div>
				<van-icon name="arrow" />
			</div>
		</div>
		<div class="bor_b pb20 flex flex_between mb20">
			<div class=""><span class="red">*</span>请假时间</div>
			<div class="flex flex_items">
				<Checkbox shape="square" name="forenoon" v-model="fc" @click="selectChange(0)" class="mr20"
					checked-color="#00d8cc">上午
				</Checkbox>
				<Checkbox shape="square" name="afternoon" v-model="ac" @click="selectChange(1)" checked-color="#00d8cc">
					下午</Checkbox>
			</div>
		</div>
		<div class="mb10 flex flex_between">
			<div class=""><span class="red">*</span>请假事由</div>
		</div>
		<textarea v-model="remark" placeholder="请填写请假事由"></textarea>
		<div class="mt20 bb" @click="submit">
			<div class="btn_contenbt main_bg cf txt_center">提交</div>
		</div>
		<Popup v-model="show" position="bottom">
			<DatetimePicker v-model="timerS" @cancel="show = false" @confirm="confirm" type="date" title="选择开始日期"
				:min-date="minDate">
			</DatetimePicker>
		</Popup>
	</div>
</template>

<script>
	import {
		Popup,
		DatetimePicker,
		Checkbox,
		CheckboxGroup
	} from "vant";
	export default {
		data() {
			return {
				id: '',
				flag: true,
				remark: '',
				show: false,
				timerS: '',
				timer: '',
				checked: false,
				minDate: new Date(),
				fc: false,
				ac: false
			}
		},
		methods: {
			submit() {
				if (!this.timer) {
					this.Toast('请选择请假日期')
					return
				}
				if (!this.fc && !this.ac) {
					this.Toast('请选择请假时间')
					return
				}
				if (!this.remark) {
					this.Toast('请填写请假事由')
					return
				}
				if (!this.flag) {
					return
				}
				this.flag = false;
				
				let times = [];
				this.ac ? times.push('afternoon') : times = times;
				this.fc ? times.push('forenoon') : times = times;
				console.log(times, JSON.stringify(times))
				// return
				this.api.userLeave({
					date: this.timerS,
					remark: this.remark,
					times: times
				}, this.id).then(res => {
					this.Toast('提交成功')
					this.flag = true;
					setTimeout(() => {
						window.history.go(-1)
					}, 1500)
				}).catch(() => {
					this.flag = true
				})
			},
			selectChange(e) {
				if (e == 0) {
					if (this.fc) {
						this.fc = true
					} else {
						this.fc = false;
					}
				} else {
					if (this.ac) {
						this.ac = true
					} else {
						this.ac = false;
					}
				}
				this.$forceUpdate()
			},
			confirm(e) {
				this.timerS = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate();
				this.timer = e.getFullYear() + '年' + (e.getMonth() + 1) + '月' + e.getDate() + '日';
				this.show = false;
				// this.getList()
			},
		},
		created() {
			this.id = this.$route.query.id;
			this.flag = true;
			let d = new Date().getTime() + 1000 * 60 * 60 * 24;
			this.minDate = new Date(d)
		},
		components: {
			Popup,
			DatetimePicker,
			Checkbox,
			CheckboxGroup
		}
	}
</script>

<style scoped="scoped">
	textarea {
		border: 1px solid #ddd;
		border-radius: 10px;
		height: 200px;
		width: 100%;
		padding: 10px;
		box-sizing: border-box;
	}

	.btn_contenbt {
		height: 50px;
		line-height: 50px;
		border-radius: 10px;
	}
</style>
